import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalStyles from './modalStyles';

const Modal = ({ size, position, ...props }) => {
  useEffect(() => {
    if (props.visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = null;
    }

    return () => {
      document.body.style.overflow = null;
    };
  }, [props.visible]);

  return (
    <ModalStyles.OverlayStyles position={position} {...props}>
      <ModalStyles $size={size} {...props}>
        {props.children}
      </ModalStyles>
    </ModalStyles.OverlayStyles>
  );
};

Modal.propTypes = {
  position: PropTypes.oneOf(['start', 'center']),
  size: PropTypes.oneOf(['small', 'middle', 'large', 'fullScreen']),
  backgroundColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
};

Modal.defaultProps = {
  position: 'center',
  backgroundColor: 'white',
  size: 'small',
  visible: false,
};

const ModalNavigation = props => {
  return <ModalStyles.NavigationStyles {...props}>{props.children}</ModalStyles.NavigationStyles>;
};

ModalNavigation.propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalHeader = props => {
  return <ModalStyles.HeaderStyles {...props}>{props.children}</ModalStyles.HeaderStyles>;
};

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalHeading = props => {
  return <ModalStyles.HeadingStyles {...props}>{props.children}</ModalStyles.HeadingStyles>;
};

ModalHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalBody = props => {
  return <ModalStyles.BodyStyles {...props}>{props.children}</ModalStyles.BodyStyles>;
};

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalFooter = props => {
  return <ModalStyles.FooterStyles {...props}>{props.children}</ModalStyles.FooterStyles>;
};

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

const ModalPaging = props => {
  return <ModalStyles.PagingStyles {...props}>{props.children}</ModalStyles.PagingStyles>;
};

ModalPaging.propTypes = {
  children: PropTypes.node.isRequired,
};

Modal.Navigation = ModalNavigation;
Modal.Header = ModalHeader;
Modal.Heading = ModalHeading;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Paging = ModalPaging;

export default Modal;
